module.exports = __webpack_public_path__ + "static/img/70c3778b32a6dca0f0d57675948f72cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sol_icon3.png
// module id = sKPc
// module chunks = 1